<template>
    <div class="menu_tree">
        <div class="btn_container">
            <el-button
                class="leader-common-button"
                @click="addNewOne"
                size="small"
                >新增</el-button
            >
            <el-button
                class="leader-common-button"
                @click="editNewOne"
                size="small"
                >修改</el-button
            >
            <el-button
                class="leader-common-button"
                @click="deleteNewOne"
                size="small"
                >删除</el-button
            >
        </div>
        <el-scrollbar style="height:calc(100% - 3rem)">
            <el-tree
                default-expand-all
                highlight-current
                :expand-on-click-node="false"
                :data="treeList"
                :props="defaultProps"
                @node-click="handleNodeClick"
                node-key="menu_id"
                ref="tree"
            ></el-tree>
        </el-scrollbar>
    </div>
</template>
<script>
export default {
    props: {
        treeList: JSON
    },
    data() {
        return {
            defaultProps: {
                children: "childlist",
                label: "menu_name"
            }
        };
    },
    methods: {
        // 新增按钮点击
        addNewOne() {
            this.$emit("addNewOne");
        },
        // 修改按钮点击
        editNewOne() {
            this.$emit("editNewOne");
        },
        // 删除按钮点击
        deleteNewOne() {
            this.$emit("deleteNewOne");
        },
        // tree节点点击
        handleNodeClick(val) {
            this.$emit("treeVal", val);
        }
    },
    created() {}
};
</script>
<style lang="scss">
.menu_tree {
    width: 100%;
    height: calc(100% - 5.5rem);
    .btn_container {
        display: flex;
        justify-content: space-between;
        // margin: 1rem;
        text-align: left;
    }
}
</style>
